import * as foundation from "../foundation"
import { createBackgroundColors } from "./background"
import {
  createBorderWidths,
  createBorderColors,
  createBorderRadii,
} from "./border"
import {
  createFonts,
  createFontSizes,
  createLineHeights,
  createFontWeights,
  createTextColors,
} from "./typography"
import { createIconSizes, createIconColors } from "./icons"

export const backgroundColors = createBackgroundColors(foundation)
export const borderWidths = createBorderWidths(foundation)
export const borderColors = createBorderColors(foundation)
export const borderRadii = createBorderRadii(foundation)
export const fonts = createFonts(foundation)
export const fontSizes = createFontSizes(foundation)
export const lineHeights = createLineHeights(foundation)
export const fontWeights = createFontWeights(foundation)
export const textColors = createTextColors(foundation)
export const iconSizes = createIconSizes(foundation)
export const iconColors = createIconColors(foundation)
